import type { Options } from 'minisearch';
import type { HelpSection } from './types';

/** One MiniSearch document per article section. Shared by the build (index) and the browser (loadJSON). */
export interface HelpSearchDoc extends HelpSection { id: string; title: string; summary: string; keywords: string; area: string }

const STOP = new Set(['a', 'an', 'and', 'the', 'to', 'of', 'in', 'on', 'for', 'is', 'it', 'or', 'how', 'do', 'i', 'my', 'can', 'what', 'with', 'be', 'you', 'your']);
/** British and American spellings meet in the index ("organise" finds "organize" and back). */
const VARIANTS: [RegExp, string][] = [[/ise(s|d)?$/, 'ize$1'], [/isation$/, 'ization'], [/our$/, 'or'], [/ogue$/, 'og'], [/tre$/, 'ter']];
export const normaliseTerm = (term: string): string | null => {
  const t = term.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  if (!t || STOP.has(t)) return null;
  let out = t;
  for (const [re, to] of VARIANTS) if (re.test(out) && out.length > 5) { out = out.replace(re, to); break; }
  return out;
};

export const SEARCH_OPTIONS: Options<HelpSearchDoc> = {
  idField: 'id',
  fields: ['title', 'heading', 'text', 'keywords', 'summary'],
  storeFields: ['key', 'anchor', 'heading', 'text', 'title', 'area'],
  processTerm: normaliseTerm,
  searchOptions: { boost: { title: 4, keywords: 3, heading: 2.5, summary: 1.5 }, fuzzy: 0.2, prefix: true, combineWith: 'AND' },
};

/** Stored section text is cut to this many characters (enough for a highlighted snippet). */
export const STORED_TEXT = 700;
